import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';
import type { PermissionEntity } from '../entities/MembershipEntity.js';

interface Deps { membershipRepository: IMembershipRepository; }
export interface CreatePermissionInput { orgId: string; resource: string; action: string; }
export function createCreatePermissionUseCase({ membershipRepository }: Deps) {
  return async function createPermission(input: CreatePermissionInput): Promise<PermissionEntity> {
    return membershipRepository.createPermission(input);
  };
}
